import { PublicUrlAdapter } from '@magicdoorinc/file';
import { createMutation, createTriggerResource, toast, useLocalization } from '@magicdoorinc/ui';
import { useParams } from '@solidjs/router';
import { createMagicDoorContext } from '~/contexts/utils';
import { leaseInvoiceRepository } from '~/repositories/leaseInvoiceRepository';
import { fileService } from '~/utils/file';

export const [LeaseInvoiceProvider, useLeaseInvoice] = createMagicDoorContext('LeaseInvoice', () => {
  const params = useParams<{ leaseId: string }>();
  const { t } = useLocalization();
  const [leaseInvoice, getLeaseInvoice, { refetch: refetchLeaseInvoice }] = createTriggerResource(async (billId: string) => {
    return await leaseInvoiceRepository.getLeaseInvoice(params.leaseId, billId);
  });

  const [leaseInvoiceFile, getLeaseInvoiceFile] = createTriggerResource(async (invoiceId: string) => {
    return await leaseInvoiceRepository.getLeaseInvoiceFile(params.leaseId, invoiceId);
  });

  const createLeaseInvoice = createMutation(async (billId: string) => {
    const response = await leaseInvoiceRepository.createLeaseInvoice(params.leaseId, billId);
    refetchLeaseInvoice();
    toast.success(t('Operation successful'));
    return response;
  });

  const send = createMutation(async (invoiceId: string) => {
    const response = await leaseInvoiceRepository.send(params.leaseId, invoiceId);
    refetchLeaseInvoice();
    toast.success(t('Operation successful'));
    return response;
  });

  const handleDownloadFile = createMutation(async () => {
    const file = leaseInvoiceFile();
    if (!file?.id) return;
    await fileService.downloadFile(new PublicUrlAdapter({ reference: file.id, name: file.name }));
    toast.success(t('Operation successful'));
  });

  return {
    leaseInvoice,
    getLeaseInvoice,
    createLeaseInvoice,
    leaseInvoiceFile,
    getLeaseInvoiceFile,
    send,
    handleDownloadFile,
  };
});
